import { AxiosResponse } from 'axios';
import { call, put, select, takeLatest } from 'redux-saga/effects';

import { collectBonus, getBonus } from '../../services/api';
import { playSound } from '../../utils/sound';
import { profileRequest, updateBonusCooldown } from '../auth/authActions';
import {
	bonusInitFailure,
	bonusInitRequest,
	bonusInitSuccess,
	collectBonusFailure,
	collectBonusRequest,
	collectBonusSuccess,
} from './bonusActions';

function getCollectedAtFromResponseDate(dateHeader?: string) {
	if (!dateHeader) return new Date().toISOString();

	const parsed = new Date(dateHeader);
	return Number.isNaN(parsed.getTime()) ? new Date().toISOString() : parsed.toISOString();
}

function* initBonusWorker() {
	try {
		const res: AxiosResponse = yield call(getBonus);
		// Backend may return either direct payload or wrapped { name, status, data }.
		const bonus = res?.data?.data ?? res?.data;

		if (bonus) {
			yield put(bonusInitSuccess({ bonus }));
		} else {
			yield put(bonusInitFailure('Package not found'));
		}
	} catch (e: any) {
		console.log('[saga] package error:', e);
		const msg = e?.message || e?.response?.data?.error || 'Failed to load package';
		yield put(bonusInitFailure(msg));
	}
}

function* collectBonusWorker() {
	try {
		console.log('[saga] Collecting bonus...');
		const res: AxiosResponse = yield call(collectBonus);
		// Backend may return either direct payload or wrapped { name, status, data }.
		const data = res?.data?.data ?? res?.data;
		const isVip: boolean = yield select((s: any) => !!s?.auth?.user?.isVip);
		const bonusHours: string | undefined = yield select((s: any) => s?.auth?.user?.bonusHours);
		const prevDaysCollected = Number(data?.previous_days_collected ?? 0);
		const claimedIdx = Math.max(0, prevDaysCollected - 1);
		const amounts = (isVip ? data?.vipAmounts : data?.bonusAmounts) as number[] | undefined;
		const chips = Number(data?.chips ?? amounts?.[claimedIdx] ?? 0);
		const collectedAt = getCollectedAtFromResponseDate(res?.headers?.date);

		console.log('[saga] Bonus collected:', chips, 'chips');

		yield put(updateBonusCooldown({ collectedAt, bonusHours }));
		yield put(collectBonusSuccess({ chips }));
		playSound('CoinGain'); // v1 modal.receive.bonus.component
		console.log('[saga] Refreshing profile...');
		yield put(profileRequest());
		yield call(delay, 500);
		console.log('[saga] Refreshing bonus data...');
		yield put(bonusInitRequest());
	} catch (e: any) {
		console.error('❌ [saga] Collect bonus error:', e);
		yield put(collectBonusFailure(e?.message || 'Collect failed'));
	}
}

function delay(ms: number) {
	return new Promise(resolve => setTimeout(resolve, ms));
}

export function* bonusRootSaga() {
	yield takeLatest(bonusInitRequest.type, initBonusWorker);
	yield takeLatest(collectBonusRequest.type, collectBonusWorker);
}
